<template>
  <div>
    <div class="vx-card" v-if="loaded">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.firstName"
              name="fName"
              :label="$t('Firstname')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('fName')">{{
              errors.first("fName")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.lastName"
              name="lName"
              :label="$t('Lastname')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('lName')">{{
              errors.first("lName")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.socialSecurityNumber"
              name="idNumber"
              :label="$t('SocialSecurityNumber')"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                digits: '10',
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('idNumber')">{{
              errors.first("idNumber")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.birthCertificateNumber"
              name="certificateNumber"
              :label="$t('BirthCertificateNumber')"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificateNumber')"
              >{{ errors.first("certificateNumber") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.storeName"
              name="store"
              v-validate="'required'"
              :label="$t('ShopName')"
            />
            <span class="text-danger text-sm" v-show="errors.has('store')">{{
              errors.first("store")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.supplierOwnerQuery.ownerName"
              name="owner"
              disabled
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                max: '15',
                min: '10',
              }"
              :label="$t('SupplierOwnerNumber') + ' (نام کاربری)'"
            />
            <span class="text-danger text-sm" v-show="errors.has('owner')">{{
              errors.first("owner")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phone in individualInfo.supplierPhones"
              :key="phone.id"
              v-model="phone.area"
              name="area"
              v-validate="{ regex: '^([0-9]+)$' }"
              :label="$t('PhoneArea')"
            />
            <span class="text-danger text-sm" v-show="errors.has('area')">{{
              errors.first("area")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phone in individualInfo.supplierPhones"
              :key="phone.id"
              v-model="phone.number"
              name="number"
              v-validate="{ regex: '^([0-9]+)$' }"
              :label="$t('PhoneNumber')"
            />
            <span class="text-danger text-sm" v-show="errors.has('number')">{{
              errors.first("number")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.emailAddress"
              name="email"
              v-validate="'email'"
              :label="$t('Email')"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("Country") }}</label>
            <v-select
              label="name"
              :options="allCountries"
              name="country"
              :reduce="(x) => ({ id: x.id, name: x.name })"
              v-validate="{ required: true }"
              ref="countryListSelect"
              class="mb-4"
              v-for="address in individualInfo.addressInfo"
              :key="address.id"
              :value="
              address.supplierCountryInfo  ?
                allCountries.filter(
                  (x) =>
                    x.id ==
                    individualInfo.addressInfo[0].supplierCountryInfo.countryId
                )[0].name :''
              "
              @input="selectCountry"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('country')">{{
              errors.first("country")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("Province") }}</label>
            <v-select
              label="name"
              :options="allProvinces"
              name="province"
              :reduce="(x) => ({ id: x.id, name: x.name })"
              v-validate="{ required: true }"
              ref="provinceListSelect"
              class="mb-4"
              v-for="address in individualInfo.addressInfo"
              :key="address.id"
              :value="
                address.supplierProvinceInfo.provinceId
                  ? allProvinces.filter(
                      (x) =>
                        x.id ==
                        individualInfo.addressInfo[0].supplierProvinceInfo
                          .provinceId
                    )[0].name
                  : ''
              "
              @input="selectProvince"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('province')">{{
              errors.first("province")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label mt-4">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="city"
              :options="allCities"
              :reduce="(x) => ({ cityId: x.id, cityName: x.name })"
              v-for="address in individualInfo.addressInfo"
              :key="address.id"
              :value="
                address.supplierCityInfo.cityId
                  ? allCities.filter(
                      (x) => x.id == address.supplierCityInfo.cityId
                    )[0].name
                  : ''
              "
              v-validate="{ required: true }"
              :clearable="true"
              ref="cityListSelect"
              @input="selectCity"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('city')">{{
              errors.first("city")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2"
              v-for="address in individualInfo.addressInfo"
              :key="address.id"
              v-model="address.postalCode"
              name="postalCode"
              v-validate="{ regex: '^([0-9]+)$', digits: '10' }"
              :label="$t('PostalCode')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('postalCode')"
              >{{ errors.first("postalCode") }}</span
            >
          </div>
          <span class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("EconomicCode") }}</label>
            <div
              class="vx-row w-full p-0 mx-0 vs-input--input vs-input--input.normal"
            >
              <vs-input
                class="vs-input-no-border w-1/3"
                v-model="economicCodeSpecific"
                name="economicCode"
                maxlength="4"
                placeholder="کد اقتصادی"
                v-validate="{
                  regex: '^([0-9]+)$',
                  required: 'true',
                  digits: '4',
                }"
              />
              <vs-input
                class="vs-input-no-border w-2/3"
                v-model="individualInfo.socialSecurityNumber"
                name="socialSecurityNumber"
                disabled
              />
            </div>
            <span
              class="text-danger text-sm"
              v-show="errors.has('economicCode')"
              >{{ errors.first("economicCode") }}</span
            >
          </span>
          <div class="vx-col lg:w-3/4 md:w-2/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="address in individualInfo.addressInfo"
              :key="address.id"
              v-model="address.address"
              name="address"
              :label="$t('Address')"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-checkbox
              @click="setForeignSubjects($event)"
              :checked="
                individualInfo.individualSupplierTaxInfo.isForeignSubjects
              "
              v-model="
                individualInfo.individualSupplierTaxInfo.isForeignSubjects
              "
              class="px-3"
              >{{ $t("NotIranianCitizen") }}
            </vs-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-3" v-if="loaded">
      <div class="vx-card__header">
        <div class="vx-card__title">
          <h4>{{ $t("TaxInfo") }}</h4>
        </div>
      </div>
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("Province") }}</label>
            <v-select
              label="name"
              :options="allProvincesOfTadbir"
              name="provinceOfTadbir"
              :reduce="(x) => x.id"
              v-validate="{ required: 'true' }"
              ref="provinceOfTadbirListSelect"
              v-model="individualInfo.individualSupplierTaxInfo.provinceId"
              :value="
                allProvincesOfTadbir.filter(
                  (x) =>
                    x.id == individualInfo.individualSupplierTaxInfo.provinceId
                )[0].name
              "
              @input="selectProvinceOfTadbir"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('provinceOfTadbir')"
              >{{ errors.first("provinceOfTadbir") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label mt-4">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="cityOfTadbir"
              :options="allCitiesOfTadbir"
              :reduce="(x) => x.id"
              v-model="individualInfo.individualSupplierTaxInfo.cityId"
              :value="
                individualInfo.individualSupplierTaxInfo.cityId
                  ? allCitiesOfTadbir.filter(
                      (x) =>
                        x.id == individualInfo.individualSupplierTaxInfo.cityId
                    )[0].name
                  : ''
              "
              v-validate="{ required: 'true' }"
              :clearable="true"
              ref="cityOfTadbirListSelect"
              @input="selectCityOfTadbir"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('cityOfTadbir')"
              >{{ errors.first("cityOfTadbir") }}</span
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right submit-btn"
              @click.prevent="submitForm()"
              :disabled="disabled"
              >{{ $t("Save") }}</vs-button
            >
            <vs-button
              type="filled"
              class="float-right ml-4"
              id="cancel-btn"
              @click.prevent="cancel()"
              :disabled="disabled"
              >{{ $t("Cancel") }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
#cancel-btn {
  background: #fd4c4c !important;
}

#cancel-btn:hover {
  -webkit-box-shadow: 0 8px 25px -8px #fd4c4c !important;
  box-shadow: 0 8px 25px -8px !important;
  color: #ab6c6c !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    fName: {
      required: "لطفا نام را وارد نمایید.",
    },
    lName: {
      required: "لطفا نام خانوادگی را وارد نمایید.",
    },
    idNumber: {
      required: "لطفا کدملی را وارد نمایید.",
      regex: "کدملی نامعتبر می باشد.",
      digits: "کدملی نامعتبر می باشد.",
    },
    certificateNumber: {
      required: "لطفا شماره شناسنامه را وارد نمایید.",
      regex: "شماره شناسنامه نامعتبر می باشد.",
    },
    email: {
      email: "پست الکترونیک نامعتبر می باشد.",
    },
    area: {
      regex: "پیش شماره نامعتبر می باشد.",
    },
    number: {
      regex: "شماره تلفن نامعتبر می باشد.",
    },
    postalCode: {
      regex: "کدپستی نامعتبر می باشد.",
      digits: "کدپستی نامعتبر می باشد.",
    },
    economicCode: {
      required: "لطفا کد اقتصادی را وارد نمایید.",
      regex: "کد اقتصادی نامعتبر می باشد.",
      digits: "کد اقتصادی نامعتبر می باشد.",
    },
    country: {
      required: "لطفا کشور را انتخاب نمایید.",
    },
    province: {
      required: "لطفا استان را انتخاب نمایید.",
    },
    city: {
      required: "لطفا شهر را انتخاب نمایید.",
    },
    store: {
      required: "لطفا نام مغازه را وارد نمایید.",
    },
    owner: {
      required: "لطفا شماره موبایل مالک اصلی را وارد نمایید.",
      regex: "شماره موبایل مالک اصلی نامعتبر می باشد.",
      max: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
      min: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
    },
    provinceOfTadbir: {
      required: "لطفا استان را در قمست مشخصات مالیاتی انتخاب نمایید.",
    },
    cityOfTadbir: {
      required: "لطفا شهر را در قمست مشخصات مالیاتی انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      titleTaxTypes: [
        { name: "خصوصی", id: 0 },
        { name: "دولتی", id: 1 },
        { name: "مشارکت مدنی", id: 2 },
      ],
      typeTaxTypes: [
        { name: "وزارت", id: 1 },
        { name: "موسسه دولتی", id: 2 },
        { name: "شرکت دولتی", id: 3 },
        { name: "سایر دستگاه‌های دولتی", id: 4 },
        { name: "نهادهای عمومی غیر‌دولتی", id: 5 },
        { name: "بخش خصوصی", id: 6 },
        { name: "سایر", id: 7 },
      ],
      individualInfo: {},
      individualInfoForApi: {},
      economicCodeSpecific: "",
      disabled: false,
      loaded: false,
    };
  },
  mounted() {
    this.fetchProvinces();
    this.fetchCountry();
    this.fetchProvincesOfTadbir();
    this.load();
  },
  computed: {
    ...mapGetters({
      allProvinces: "country/provinceList",
      allCountries: "country/countryList",
      allCities: "country/cityList",
      locationInfo: "country/details",
      individual: "parties/supplierDetails",
      allProvincesOfTadbir: "country/provinceOfTadbirList",
      allCitiesOfTadbir: "country/cityOfTadbirList",
    }),
  },
  methods: {
    ...mapActions({
      fetchProvinces: "country/fetchProvinces",
      fetchCountry: "country/fetchCountry",
      fetchProvincesById: "country/fetchProvincesByIdSupplier",
      fetchCitiesById: "country/fetchCitiesById",
      fetchSingleSupplier: "parties/fetchSingleSupplier",
      updateIndividual: "individual/updateSupplier",
      fetchProvincesOfTadbir: "country/fetchProvincesOfTadbir",
      fetchCitiesOfTadbirById: "country/fetchCitiesOfTadbirById",
    }),
    selectProvince(province) {
      this.individualInfo.addressInfo[0].supplierCityInfo = {};

      this.individualInfo.addressInfo[0].supplierProvinceInfo.provinceId =
        province.id;
      this.individualInfo.addressInfo[0].supplierProvinceInfo.provinceName =
        province.name;
      this.fetchCitiesById(province.id);
      // if (this.$refs.cityListSelect) {
      //   this.$refs.cityListSelect[0].clearSelection();
      // }
    },
    selectCountry(country) {
      this.individualInfo.addressInfo[0].supplierProvinceInfo = {};
      this.individualInfo.addressInfo[0].supplierCityInfo = {};
      this.individualInfo.addressInfo[0].supplierCountryInfo=
      {
        countryId:country.id,
        countryName:country.name
      }
      this.fetchProvincesById(country.id);
      // if (this.$refs.provinceListSelect) {
      //   this.$refs.provinceListSelect[0].clearSelection();
      // }
      // if (this.$refs.cityListSelect) {
      //   this.$refs.cityListSelect[0].clearSelection();
      // }
    },
    selectProvinceOfTadbir(provinceId) {
      this.individualInfo.individualSupplierTaxInfo.cityId = null;
      this.individualInfo.individualSupplierTaxInfo.provinceId = provinceId;
      this.fetchCitiesOfTadbirById(provinceId);
      if (this.$refs.cityOfTadbirListSelect) {
        this.$refs.cityOfTadbirListSelect.clearSelection();
      }
    },
    selectCity(city) {
      if (city) {
        this.individualInfo.addressInfo[0].supplierCityInfo.cityId =
          city.cityId;
        this.individualInfo.addressInfo[0].supplierCityInfo.cityName =
          city.cityName;
      }
    },
    selectCityOfTadbir(cityId) {
      if (cityId) {
        this.individualInfo.individualSupplierTaxInfo.cityId = cityId;
      }
    },
    createModelForApi(individualInfo) {
      this.individualInfoForApi = {
        emailAddress: individualInfo.emailAddress,
        supplierOwnerName: individualInfo.supplierOwnerQuery.ownerName,
        economicCode: this.economicCodeSpecific,
        addressesInfoCommand: individualInfo.addressInfo,
        supplierPhonesCommand: individualInfo.supplierPhones,
        id: individualInfo.id,
        firstname: individualInfo.firstName,
        lastname: individualInfo.lastName,
        socialSecurityNumber: individualInfo.socialSecurityNumber,
        birthCertificateNumber: individualInfo.birthCertificateNumber,
        storeName: individualInfo.storeName,
        individualSupplierTaxInfo: individualInfo.individualSupplierTaxInfo,
      };
    },
    setForeignSubjects(val) {
      if (val.target.checked) this.individualSupplierTaxInfo.isForeignSubjects = true;
      else this.individualSupplierTaxInfo.isForeignSubjects = false;
    },
    load() {
      var id = this.$route.params.id;
      this.fetchSingleSupplier(id).then(() => {
        this.individualInfo = JSON.parse(JSON.stringify(this.individual));
        if (this.individualInfo.economicCode) {
          this.economicCodeSpecific =
            this.individualInfo.economicCode.slice(-4);
        }
        this.fetchCitiesById(
          this.individualInfo.addressInfo[0].supplierProvinceInfo.provinceId
        ).then(() => {
          this.fetchCitiesOfTadbirById(
            this.individualInfo.individualSupplierTaxInfo.provinceId
          ).then(() => {
            this.fetchProvincesById(
              this.individualInfo.addressInfo[0].supplierCountryInfo
                ? this.individualInfo.addressInfo[0].supplierCountryInfo
                    .countryId
                : 1
            ).then(() => {
              this.loaded = true;
            });
          });
        });
      });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.individualSupplierTaxInfo.isForeignSubjects!==true){
            this.individualSupplierTaxInfo.isForeignSubjects=false;
          }
          this.createModelForApi(this.individualInfo);
          this.individualInfoForApi.economicCode =
            this.individualInfoForApi.socialSecurityNumber.concat(
              this.economicCodeSpecific
            );
          this.updateIndividual(this.individualInfoForApi).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.push("/Suppliers/Index");
            });
            this.$validator.reset();
          });
        } else {
          // form have errors
        }
      });
    },
    cancel() {
      this.$router.push("/Suppliers/Index");
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
